<template>
  <span
    v-if="span"
    ref="eSpan"
    class="ellipsis-div"
    :placeholder="displayText"
    v-html="usePlaceholder ? '' : displayText"
  />
  <div
    v-else
    ref="eDiv"
    class="ellipsis-div"
    :placeholder="displayText"
    v-html="usePlaceholder ? '' : displayText"
  />
</template>

<script>
/**
 * Div with ellipsis
 */
import $ from 'jquery';


function copyFontStyleProperties(from, to) {
  const style = window.getComputedStyle(from, null);
  to.style.fontSize = style.getPropertyValue('font-size');
  to.style.fontWeight = style.getPropertyValue('font-weight');
  to.style.fontFamily = style.getPropertyValue('font-family');
  to.style.lineHeight = style.getPropertyValue('line-height');
  to.style.whiteSpace = style.getPropertyValue('white-space');
  // Padding
  to.style.paddingTop = style.getPropertyValue('padding-top');
  to.style.paddingRight = style.getPropertyValue('padding-right');
  to.style.paddingBottom = style.getPropertyValue('padding-bottom');
  to.style.paddingLeft = style.getPropertyValue('padding-left');
  return to;
}

export default {
  name: 'EllipsisDiv',

  props: {
    text: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    span: Boolean,
  },

  data() {
    return {
      testElt: null,
      refStr: this.span ? 'eSpan' : 'eDiv',
      forceCompute: 1,
    };
  },

  computed: {
    usePlaceholder() {
      return !this.text && this.placeholder !== undefined;
    },
    displayText() {
      this.forceCompute;
      let el = this.testElt;
      const refDiv = this.$refs[this.refStr];
      const text = this.usePlaceholder ? this.placeholder : this.text;
      if (!text) {
        return '';
      }
      if (!refDiv) {
        return this.text;
      }
      el = copyFontStyleProperties(refDiv, el);
      const rect = refDiv.getBoundingClientRect();
      el.style.width = `${rect.width}px`;
      el.style.height = `${rect.height}px`;
      el.innerHTML = text;
      const linesArray = text.split('\n');
      const lines = [];
      let i = 0;
      let j = 0;
      let jlen = 0;
      let html = '';
      for (let len = linesArray.length; i < len; i++) {
        lines.push(linesArray[i].split(/\s/));
      }
      i--;
      while (el.scrollHeight > el.offsetHeight) {
        if (lines[i].length === 0) {
          lines.pop();
          i = lines.length - 1;
        }
        if (lines.length === 0) break;
        lines[i].pop();
        html = '';
        for (j = 0, jlen = lines.length; j < jlen; j++) {
          html += (j > 0 ? '\n' : '') + lines[j].join(' ');
        }
        el.innerHTML = `${html}...`;
      }
      return el.innerHTML;
    },
  },

  mounted() {
    this.testElt = document.createElement(this.span ? 'span' : 'div');
    this.testElt.className = 'ellipsis-size-monitor';
    const parentElt = this.$el.parentElement || document.body;
    parentElt.insertBefore(this.testElt, this.$el);

    $(window).on(`resizeEnd.${this.uuid}`, () => {
      this.forceCompute++;
    });
  },

  beforeDestroy() {
    if (this.testElt) {
      $(this.testElt).remove();
    }
  },
};
</script>

<style lang="scss">
.ellipsis-div {
  overflow: hidden;
}
.ellipsis-size-monitor {
  box-sizing: border-box;
  position: absolute;
  pointer-events: none;
  visibility: hidden;
  z-index: -1;
}
</style>
